import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import {errorEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import {CSSTransition} from 'react-transition-group';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const ContactUsErrorPrivate = (props) => {
  const [mount, setMount] = useState(false);

  let mainImg = require('../images/icons-error.svg');

  useEffect(() => {
    if (props.currentStep === errorEnum.CONTACTPRIVATE) {
      setMount(true);
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  return (
    <CSSTransition key={17} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'רק רגע...'} classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'אנחנו רואים שיש לך כבר פנייה פתוחה\nונציג שלנו צריך לחזור לנייד שהזנת'} />
          </Col>
        </Row>
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default ContactUsErrorPrivate;
